import axiosHttp from "services/axiosHttp";
import PermissionManager from "utils/class/PermissionManager";
import { USER } from "constants/AuthConstant";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchStatusLogs = createAsyncThunk("fetchStatusLogs", async ({ page, limit, filters }, { rejectWithValue }) => {
	const user = PermissionManager.getItem(USER)?.user;
	const channel_id = user?.user_channel?.[0]?.channel_uuid;
	if (!channel_id) throw new Error("Channel ID not found");

	const params = new URLSearchParams({
		page: page,
		limit: limit,
		keyword: filters?.keyword ?? "",
		start_date: filters?.start_date ?? "",
		end_date: filters?.end_date ?? "",
	});

	try {
		const response = await axiosHttp.get(`channel/${channel_id}/payment/request/logs?${params}`);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wong");
	}
});

const StatusLogSlice = createSlice({
	name: "StatusLogSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchStatusLogs.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchStatusLogs.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage;
			state.total = action.payload.total;
		});
		builder.addCase(fetchStatusLogs.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default StatusLogSlice.reducer;
